<template>
  <div>
    <b-card no-body>
      <b-card-header>
          <h3 class="float-left"><i class='fa fa-globe'></i> Game Detail</h3>
          <b-button variant="primary" class="float-right" @click="showAddModal" v-if="checkAccessPrivilege('ScratchCard.Settings.Create')">Create Scratch Card</b-button>
      </b-card-header>
      <b-card-body>
        <div class="overflow-auto">
          <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
            <template v-slot:row-details="data">
              <p v-html="data.item.Description"></p>
            </template>
            <template v-slot:cell(BannerUrl)="data">
              <img :src="data.item.BannerUrl" width="120px"/>
            </template>
            <template v-slot:cell(CoverUrl)="data">
              <img :src="data.item.CoverUrl" width="120px"/>
            </template>
            <template v-slot:cell(Price)="data">
              {{ data.item.Price }} {{ (data.item.Type === 1) ? 'Credits' : (data.item.Type === 2) ? 'Points' : '' }}
            </template>
            <template v-slot:cell(DailyPayoutLimit)="data">
              {{ format(data.item.DailyPayoutLimit, '0,0.00') }}
            </template>
            <template v-slot:cell(Status)="data">
              <b-badge variant="success" v-if="data.item.Status === 1">Enabled</b-badge>
              <b-badge variant="danger" v-else-if="data.item.Status === 0">Disabled</b-badge>
            </template>
            <template v-slot:cell(Action)="data">
              <b-button class="btn-sm" variant="success" @click="showRewardSettings(data.item)">Reward Settings</b-button>
              <b-button class="btn-sm" variant="info" @click="showDetail(data.item)">{{(data.item._showDetails) ? `Hide Detail` : `View Detail`}}</b-button>
              <b-button class="btn-sm" variant="warning" @click="showUpdateModal(data.item)" v-if="checkAccessPrivilege('ScratchCard.Settings.Update')">Edit</b-button>
            </template>
          </b-table>
        </div>
        <nav>
          <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card-body>
    </b-card>

    <reward-setting :show-modal="rewardSettingModal" :card-id="assignCardId" :reward-list="rewardList" :reward-setting-data="rewardSettingData" @closeModal="closeSettingModal"/>
    <add-modal :show-modal="addModal" :price-type-list="priceTypeList" @closeModal="closeAddModal"/>
    <update-modal :show-modal="updateModal" :update-data="updateData" :price-type-list="priceTypeList" @closeModal="closeUpdateModal"/>
  </div>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import AddModal from './AddSettings'
import UpdateModal from './UpdateSettings'
import RewardSetting from './RewardSetting'
import numeral from 'numeral'

export default {
  name: 'scratchcard-setting-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [
        {key: 'Id', label: 'Id'},
        {key: 'Name', label: 'Name'},
        {key: 'CardWidth', label: 'Card Width'},
        {key: 'CardHeight', label: 'Card Height'},
        {key: 'BannerUrl', label: 'Background'},
        {key: 'CoverUrl', label: 'Cover'},
        {key: 'Price', label: 'Price'},
        {key: 'DailyPayoutLimit', label: 'Daily Payout Limit'},
        {key: 'Status', label: 'Status'},
        {key: 'Order', label: 'Order'},
        {key: 'Action', label: 'Action'}
      ],
      priceTypeList: [
        {key: '1', label: 'Credits'},
        {key: '2', label: 'Points'}
      ],
      perPage: 20,
      currentPage: 1,
      updateModal: false,
      updateData: {},
      addModal: false,
      rewardList: [],
      rewardSettingModal: false,
      rewardSettingData: [],
      assignCardId: 0
    }
  },
  components: {
    AddModal,
    UpdateModal,
    RewardSetting
  },
  methods: {
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    getRowCount (item) {
      return item.length
    },
    async getAll () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + '/scratchcard/game/all', { headers: { 'Content-Type': 'application/json' } })
        this.items = data
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    showDetail (item) {
      if (item._showDetails) {
        item._showDetails = false
      } else {
        this.$set(item, '_showDetails', true)
      }
    },
    showUpdateModal (item) {
      this.updateData = item
      this.updateModal = true
    },
    closeUpdateModal () {
      this.updateData = {}
      this.updateModal = false
      this.getAll()
    },
    showAddModal () {
      this.addModal = true
    },
    closeAddModal () {
      this.addModal = false
      this.getAll()
    },
    closeSettingModal () {
      this.assignCardId = 0
      this.rewardSettingModal = false
    },
    async showRewardSettings (item) {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.post(this.API_ENDPOINT + '/scratchcard/reward/getRewardMapping', { cardId: item.Id }, { headers: { 'Content-Type': 'application/json' } })
        this.assignCardId = parseInt(item.Id)
        this.rewardSettingData = data
        this.rewardSettingModal = true
        return
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async getRewardList () {
      try {
        let { data } = await this.$http.get(this.API_ENDPOINT + '/scratchcard/reward/all?type=', { headers: { 'Content-Type': 'application/json' } })
        this.rewardList = data
        return
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    }
  },
  async created () {
    await this.getAll()
    await this.getRewardList()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/scratchcard/settings/SettingTable.vue